import { useEffect, useRef } from "react";
import { useLocation } from "react-router-dom";

// Meta Pixel helpers. The base snippet in public/index.html defines
// window.fbq and fires the initial PageView; these helpers add SPA
// route tracking and e-commerce conversion events on top.
export const fbTrack = (event, params = {}, opts = undefined) => {
  if (typeof window === "undefined" || !window.fbq) return;
  if (opts) window.fbq("track", event, params, opts);
  else window.fbq("track", event, params);
};

const cartValue = (product, qty = 1) => {
  const base = Number(product.price) || 0;
  const sale = Number(product.sale_price);
  const unit = sale > 0 && sale < base ? sale : base;
  return Math.round(unit * qty * 100) / 100;
};

export const fbAddToCart = (product, qty = 1) =>
  fbTrack("AddToCart", {
    content_ids: [product.id],
    content_type: "product",
    content_name: product.name,
    value: cartValue(product, qty),
    currency: "CAD",
  });

export const fbViewContent = (product) =>
  fbTrack("ViewContent", {
    content_ids: [product.id],
    content_type: "product",
    content_name: product.name,
    value: cartValue(product, 1),
    currency: "CAD",
  });

export const fbInitiateCheckout = (items) =>
  fbTrack("InitiateCheckout", {
    content_ids: items.map((i) => i.id),
    content_type: "product",
    num_items: items.reduce((n, i) => n + (i.quantity || 1), 0),
    value: items.reduce((s, i) => s + cartValue(i, i.quantity || 1), 0),
    currency: "CAD",
  });

export const fbPurchase = (items, amount, memoCode) =>
  fbTrack(
    "Purchase",
    {
      content_ids: items.map((i) => i.id),
      content_type: "product",
      num_items: items.reduce((n, i) => n + (i.quantity || 1), 0),
      value: Number(amount) || 0,
      currency: "CAD",
    },
    memoCode ? { eventID: `purchase-${memoCode}` } : undefined
  );

// Fires PageView on SPA route changes (initial load is covered by the
// base snippet). Admin panel routes are excluded.
export function MetaPixelRouteTracker() {
  const { pathname } = useLocation();
  const first = useRef(true);
  useEffect(() => {
    if (first.current) {
      first.current = false;
      return;
    }
    if (pathname.startsWith("/panel-")) return;
    if (window.fbq) window.fbq("track", "PageView");
    // GA4 SPA page_view on client-side route changes (initial load is
    // covered by the gtag('config') call in index.html).
    if (window.gtag) {
      window.gtag("event", "page_view", {
        page_path: pathname,
        page_location: window.location.href,
        page_title: document.title,
      });
    }
  }, [pathname]);
  return null;
}
